import React from 'react'
import Footer from '../navigation/Footer'
/* import { useState,useEffect } from 'react' */
function Rewards() {
    
    /* const [rewards,setrewards]=useState({})
    useEffect(()=>{
        fetch('')
        .then(res=>res.json())
        .then(data=>setrewards(data))
    },[rewards]) */

    return (
        <div>
            <div className='rewardid'>reward details</div>
            <div className='rewardid'>reward details</div>
            <div className='rewardid'>reward details</div>
            <div className='rewardid'>reward details</div>
            <Footer/>
        </div>
    )
}

export default Rewards